export default __webpack_public_path__ + "static/media/LogoBig.ea9a8422.svg";